'use client';

import type { ReactNode } from 'react';
import { useInstantSearch } from 'react-instantsearch';

// Type definition for the NoResultsBoundary component properties.

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * No Results boundary component.
 *
 * A component that render a fallback when no results are found.
 *
 * @see https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-display/react/#handling-no-results
 */

const NoResultsBoundary = ({ children, fallback }: Props) => {
  const { results } = useInstantSearch();

  // The `__isArtificial` flag makes sure not to render the fallback when no hits have been returned.
  const hasResults = !results.__isArtificial && results.nbHits > 0;

  if (!hasResults) {
    return fallback;
  }

  return children;
};

export default NoResultsBoundary;
